import React, { useState, useEffect } from 'react';
import './IssuedBookListStaff.css'; // Import your CSS file for styling
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function IssuedBookForStaffList() {
    const [issuedBooksStaff, setIssuedBooksStaff] = useState([]);
    const [loadingIssuedBooksStaff, setLoadingIssuedBooksStaff] = useState(true);
    const [errorIssuedBooksStaff, setErrorIssuedBooksStaff] = useState('');
    const [entriesToShowStaff, setEntriesToShowStaff] = useState(10);
    const [searchQueryStaff, setSearchQueryStaff] = useState('');
    const [showIssuedBookStaffList, setShowIssuedBookStaffList] = useState(true); // Assuming you want to show this by default

    // Fetch issued books for staff when the component mounts
    useEffect(() => {
        const fetchIssuedBooks = async () => {
            setLoadingIssuedBooksStaff(true);
            setErrorIssuedBooksStaff('');

            try {
                const response = await fetch(Constants.API_PATH +'/books-issued-teacher'); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error(`Failed to fetch issued books: ${response.status}`);
                }
                const data = await response.json();
                setIssuedBooksStaff(data);
            } catch (error) {
                console.error('Error fetching issued books:', error);
                setErrorIssuedBooksStaff('Failed to fetch issued books. Please check the console for details.');
            } finally {
                setLoadingIssuedBooksStaff(false);
            }
        };

        fetchIssuedBooks();
    }, [entriesToShowStaff, searchQueryStaff]); // Re-fetch when entries or search query changes

    // Handle entries change
    const handleEntriesChangeStaff = (e) => {
        setEntriesToShowStaff(e.target.value);
    };

    // Handle search change
    const handleSearchChangeStaff = (e) => {
        setSearchQueryStaff(e.target.value);
    };

    // Handle return book action
    const handleReturnBook = async (bookId) => {
        // Implement the logic to return the book
        console.log(`Returning book with ID: ${bookId}`);
    };

    // Handle cancel book action
    const handleCancelBook = async (bookId) => {
        // Implement the logic to cancel the book
        console.log(`Canceling book with ID: ${bookId}`);
    };

    return (
        showIssuedBookStaffList && (
            <div className="issued-book-staff-list-section containernew">
                {/* <nav className="breadcrumb">
                    <a href="#" className="breadcrumb-link">Home</a> /
                    <a href="#" className="breadcrumb-link">Library Management</a> /
                    <span className="breadcrumb-current">Issued Book to Parent List</span>
                </nav> */}
                <h2 className="section-title">Issued Book Parent List</h2>
                <div className="filters">
                    <div className="entries">
                        Show
                        <SearchableSelect
                            value={entriesToShowStaff}
                            onChange={handleEntriesChangeStaff}
                            options={[
                                { value: '10', label: '10' },
                                { value: '25', label: '25' },
                                { value: '50', label: '50' },
                                { value: '100', label: '100' }
                            ]}
                            className="form-select"
                            clearable={false}
                        />
                        entries
                    </div>
                    <div className="search">
                        Search:
                        <input type="text" value={searchQueryStaff} onChange={handleSearchChangeStaff} className="form-input" />
                    </div>
                </div>
                <div className="button-group">
                    <button className="back-button">Back</button>
                    <button className="excel-button">Excel</button>
                </div>
                <div className="table-responsive">
                    {loadingIssuedBooksStaff ? (
                        <p>Loading Issued Books...</p>
                    ) : errorIssuedBooksStaff ? (
                        <p>{errorIssuedBooksStaff}</p>
                    ) : (
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Staff Name</th>
                                    <th>Book Name</th>
                                    <th>Book Code</th>
                                    <th>Issue Date</th>
                                    <th>Due Date</th>
                                    
                                    <th>Return Book</th>
                                    <th>Cancel Book</th>
                                </tr>
                            </thead>
                            <tbody>
                                {issuedBooksStaff.length === 0 ? (
                                    <tr>
                                        <td colSpan="9">No data available in table</td>
                                    </tr>
                                ) : (
                                    issuedBooksStaff.map((book, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{book.staff_name}</td>
                                            <td>{book.book_name}</td>
                                            <td>{book.book_code}</td>
                                            <td>{book.issue_date}</td>
                                            <td>{book.due_date}</td>
                                            
                                            <td>
                                                <button onClick={() => handleReturnBook(book.id)}>Return</button>
                                            </td>
                                            <td>
                                                <button onClick={() => handleCancelBook(book.id)}>Cancel</button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="pagination">
                    <button disabled>Previous</button>
                    <button>Next</button>
                </div>
            </div>
        )
    );
}

export default IssuedBookForStaffList;